import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const UsersPage = lazy(() => import('./pages/UsersPage'));

export const UsersRoutes: RouteObject = {
  path: 'users',
  children: [
    { path: '', element: <UsersPage />, handle: { crumb: 'Users' } },
  ],
};
